// extracted by mini-css-extract-plugin
module.exports = {"chatButton":"ChatButton_chatButton__dMPSe","open":"ChatButton_open__np0wh","icon":"ChatButton_icon__JKMWr","label":"ChatButton_label__QRA_E"};